import { Colors, Lightning } from "@lightningjs/sdk";
import { ProgressBar } from "@lightningjs/ui";
import theme from "../../../../../lib/theme";

interface PlayerProgressTemplateSpec extends Lightning.Component.TemplateSpec {
    progress: number;
    width: number;
    showPin?: boolean;
    Progress: {
        DurationBar: typeof ProgressBar;
        Pin: object;
    };
}

export class PlayerProgress
    extends Lightning.Component<PlayerProgressTemplateSpec>
    implements Lightning.Component.ImplementTemplateSpec<PlayerProgressTemplateSpec>
{
    readonly Progress = this.getByRef("Progress")!;
    readonly DurationBar = this.Progress.getByRef("DurationBar")!;
    readonly Pin = this.Progress.getByRef("Pin")!;
    private _showPin = false;

    static override _template(): Lightning.Component.Template<PlayerProgressTemplateSpec> {
        return {
            Progress: {
                w: (w) => w,
                h: (h) => h,
                DurationBar: {
                    type: ProgressBar,
                    h: (h: number) => h,
                    w: theme.layout.w - theme.progress.offset * 2,
                    value: 0,
                    progressColor: Colors(theme.colors.text.secondary).alpha(0.7).get(),
                    backgroundColor: Colors(theme.colors.bg.accent).alpha(0.4).get()
                },
                Pin: {
                    w: theme.playback.icon.size,
                    h: theme.playback.icon.size,
                    mountY: 0.5,
                    x: 0,
                    y: (h) => h / 2,
                    alpha: 0,
                    texture: Lightning.Tools.getRoundRect(
                        theme.playback.icon.size,
                        theme.playback.icon.size,
                        theme.playback.icon.size / 2,
                        0,
                        Colors(theme.colors.text.secondary).get(),
                        true,
                        Colors(theme.colors.text.secondary).get()
                    )
                }
            }
        };
    }

    set width(value: number) {
        this.w = value;
        this.DurationBar.patch({
            w: value
        });
    }

    set showPin(value: boolean) {
        this._showPin = value;
        if (this._showPin) {
            this.Pin.patch({ alpha: 1 });
        } else {
            this.Pin.patch({ alpha: 0 });
        }
    }

    override _focus() {
        this.DurationBar.patch({
            progressColor: Colors(theme.colors.bg.primary).get()
        });
        this.Pin.patch({
            texture: Lightning.Tools.getRoundRect(
                theme.playback.icon.size,
                theme.playback.icon.size,
                theme.playback.icon.size / 2,
                0,
                Colors(theme.colors.bg.primary).get(),
                true,
                Colors(theme.colors.bg.primary).get()
            )
        });
    }

    override _unfocus() {
        this.DurationBar.patch({
            progressColor: Colors(theme.colors.bg.secondary).alpha(0.7).get()
        });
        this.Pin.patch({
            texture: Lightning.Tools.getRoundRect(
                theme.playback.icon.size,
                theme.playback.icon.size,
                theme.playback.icon.size / 2,
                0,
                Colors(theme.colors.text.secondary).get(),
                true,
                Colors(theme.colors.text.secondary).get()
            )
        });
    }

    // between 0, 1
    set progress(value: number) {
        this.DurationBar.progress(value);

        if (this._showPin) {
            // Calculate pin position: progress * width (pin is centered at mountX: 0.5)
            const pinX = value * this.w;
            this.Pin.patch({
                x: pinX
            });
        }
    }
}
